// components/ui/button.jsx
import React from "react";

const variants = {
  default: "bg-black text-white hover:bg-black/90",
  destructive: "bg-red-500 text-white hover:bg-red-500/90",
  outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
  secondary: "bg-gray-100 text-gray-900 hover:bg-gray-100/80",
  ghost: "hover:bg-gray-100 hover:text-gray-900",
  link: "text-primary underline-offset-4 hover:underline",
};

const sizes = {
  default: "h-10 px-4 py-2",
  sm: "h-9 rounded-md px-3",
  lg: "h-11 rounded-md px-8",
  icon: "h-10 w-10",
};

const Button = React.forwardRef(
  ({ className = "", variant = "default", size = "default", asChild = false, ...props }, ref) => {
    const Comp = asChild ? "span" : "button";
    
    return (
      <Comp
        className={`
          ${variants[variant] || variants.default}
          ${sizes[size] || sizes.default}
          inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50
          ${className}
        `}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";

export { Button };